import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c57af4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-spreadsheet-fill" }, null, -1))
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center col-md-6 col-sm-12" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "dropdown d-flex align-items-center" }
const _hoisted_12 = {
  href: "javascript:;",
  class: "dropdown-toggle middle-link",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_13 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1))
const _hoisted_16 = { class: "setting-data" }
const _hoisted_17 = { class: "row align-items-center" }
const _hoisted_18 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_19 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "table" }
const _hoisted_22 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_23 = { class: "d-block my-3" }
const _hoisted_24 = { class: "d-none d-md-block" }
const _hoisted_25 = { class: "d-none t-d-md-table-cell" }
const _hoisted_26 = { class: "d-none t-d-md-table-cell" }
const _hoisted_27 = { class: "d-none t-d-md-table-cell" }
const _hoisted_28 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_29 = { class: "d-none t-d-md-table-cell" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { colspan: "7" }
const _hoisted_33 = { class: "text-center py-2" }
const _hoisted_34 = { class: "d-none d-md-block" }
const _hoisted_35 = ["onClick", "title"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1))
const _hoisted_37 = {
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_38 = { style: {"padding":"5px 0"} }
const _hoisted_39 = { class: "bold" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1))
const _hoisted_42 = { style: {"padding":"5px 0"} }
const _hoisted_43 = { class: "bold" }
const _hoisted_44 = { style: {"padding":"5px 0"} }
const _hoisted_45 = { class: "bold" }
const _hoisted_46 = { style: {"padding":"5px 0"} }
const _hoisted_47 = { class: "bold" }
const _hoisted_48 = { style: {"padding":"5px 0"} }
const _hoisted_49 = { class: "bold" }
const _hoisted_50 = { style: {"padding":"5px 0"} }
const _hoisted_51 = { class: "bold" }
const _hoisted_52 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1))
const _hoisted_54 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-checklist" }, null, -1))
const _hoisted_60 = ["onClick", "title"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-spreadsheet" }, null, -1))
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-folder-minus" }, null, -1))
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock-fill" }, null, -1))
const _hoisted_66 = {
  key: 5,
  class: "dropdown-divider"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1))
const _hoisted_69 = { class: "d-none t-d-md-table-cell" }
const _hoisted_70 = { class: "d-none t-d-md-table-cell" }
const _hoisted_71 = { class: "d-none t-d-md-table-cell" }
const _hoisted_72 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_73 = { class: "d-none t-d-md-table-cell" }
const _hoisted_74 = { class: "d-none t-d-md-table-cell" }
const _hoisted_75 = { class: "sett-small-menu align-right" }
const _hoisted_76 = { class: "discl-menu dropdown" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1))
const _hoisted_78 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { key: 0 }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = { key: 1 }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-checklist" }, null, -1))
const _hoisted_87 = { key: 2 }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock-fill" }, null, -1))
const _hoisted_90 = ["title"]
const _hoisted_91 = ["onClick"]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-spreadsheet" }, null, -1))
const _hoisted_93 = { key: 4 }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-folder-minus" }, null, -1))
const _hoisted_96 = { key: 5 }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = { key: 6 }
const _hoisted_100 = ["onClick"]
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer-fill" }, null, -1))
const _hoisted_102 = { class: "col-md-6 col-sm-12" }
const _hoisted_103 = { class: "area-info" }
const _hoisted_104 = { class: "col-md-6 col-sm-12" }
const _hoisted_105 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_SalesQuoteModal = _resolveComponent("SalesQuoteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.sales_quotes), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.selectedMonthLabel), 1),
                    _createElementVNode("ul", _hoisted_13, [
                      _createElementVNode("li", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfMonths, (oMonth) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: _normalizeClass(["dropdown-item", {'active': oMonth.id == _ctx.selectedMonth}]),
                            href: "javascript:;",
                            key: oMonth.id,
                            onClick: ($event: any) => (_ctx.changeMonth(oMonth.id))
                          }, _toDisplayString(oMonth.label), 11, _hoisted_14))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.list_of_quotes_msg), 1),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.language.sales_quotes), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addSalesQuoteRecord(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.lstOfSalesQuotesInfo.length == 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printListItems()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_20),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshList()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_21, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.language.sales_quotes), 1)
                    ]),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.language.quote_nbr), 1)
                  ]),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.language.date), 1),
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.language.customer), 1),
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.language.staff), 1),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.language.total_amt), 1),
                  _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.language.quote_status), 1),
                  _hoisted_30
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.lstOfSalesQuotesInfo.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPageElts, (salesRec) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: salesRec.SalesQuoteRecord.IdQuote
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_34, [
                        _createElementVNode("a", {
                          class: _normalizeClass({'rejected' : salesRec.SalesQuoteRecord.QuoteStatus == 3}),
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.addSalesQuoteRecord(1, salesRec.SalesQuoteRecord)),
                          title: _ctx.language.preview
                        }, _toDisplayString(salesRec.SalesQuoteRecord.QuoteNbr), 11, _hoisted_35),
                        _createTextVNode("  "),
                        _createVNode(_component_RouterLink, {
                          title: _ctx.language.details,
                          to: `/app/sales/quotes/editor/${salesRec.SalesQuoteRecord.QuoteKey}`
                        }, {
                          default: _withCtx(() => [
                            _hoisted_36
                          ]),
                          _: 2
                        }, 1032, ["title", "to"])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.language.quote_nbr) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.addSalesQuoteRecord(1, salesRec.SalesQuoteRecord))
                            }, _toDisplayString(salesRec.SalesQuoteRecord.QuoteNbr), 9, _hoisted_40),
                            _createTextVNode("  "),
                            _createVNode(_component_RouterLink, {
                              title: _ctx.language.details,
                              to: `/app/sales/quotes/editor/${salesRec.SalesQuoteRecord.QuoteKey}`
                            }, {
                              default: _withCtx(() => [
                                _hoisted_41
                              ]),
                              _: 2
                            }, 1032, ["title", "to"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.language.date) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatDate(salesRec.SalesQuoteRecord.OperDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.language.customer) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(salesRec.CustomerRecord.ClientName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.language.staff) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(salesRec.Staff.FirstName + ' ' + salesRec.Staff.LastName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.language.total_amt) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesRec.TotalAmt)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.language.quote_status) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getQuoteStatus(salesRec.SalesQuoteRecord.QuoteStatus)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_52, [
                          _hoisted_53,
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.addSalesQuoteRecord(1, salesRec.SalesQuoteRecord))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_55),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteQuoteRecord(salesRec.SalesQuoteRecord))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_56),
                            (salesRec.SalesQuoteRecord.QuoteStatus != 2)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_57))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus == 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.confirmSalesQuote(salesRec.SalesQuoteRecord))
                                }, [
                                  _hoisted_59,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.confirm), 1)
                                ], 8, _hoisted_58))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus == 1)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.convertQuoteToOrder(salesRec.SalesQuoteRecord)),
                                  title: _ctx.language.convert_to_order_title
                                }, [
                                  _hoisted_61,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.convert), 1)
                                ], 8, _hoisted_60))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus == 1)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 3,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.rejectSalesQuote(salesRec.SalesQuoteRecord))
                                }, [
                                  _hoisted_63,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.reject), 1)
                                ], 8, _hoisted_62))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus == 2)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 4,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.completeOrder(salesRec.SalesQuoteRecord))
                                }, [
                                  _hoisted_65,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.lock), 1)
                                ], 8, _hoisted_64))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus != 0)
                              ? (_openBlock(), _createElementBlock("hr", _hoisted_66))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus != 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 6,
                                  class: "dropdown-item py-2",
                                  href: "javascript:;",
                                  onClick: ($event: any) => (_ctx.printSalesQuoteRecord(salesRec))
                                }, [
                                  _hoisted_68,
                                  _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                                ], 8, _hoisted_67))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.appFxs.formatDate(salesRec.SalesQuoteRecord.OperDate)), 1),
                    _createElementVNode("td", _hoisted_70, _toDisplayString(salesRec.CustomerRecord.ClientName), 1),
                    _createElementVNode("td", _hoisted_71, _toDisplayString(salesRec.Staff.FirstName + ' ' + salesRec.Staff.LastName), 1),
                    _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesRec.TotalAmt)), 1),
                    _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.getQuoteStatus(salesRec.SalesQuoteRecord.QuoteStatus)), 1),
                    _createElementVNode("td", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("span", _hoisted_76, [
                          _hoisted_77,
                          _createElementVNode("ul", _hoisted_78, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.addSalesQuoteRecord(1, salesRec.SalesQuoteRecord))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                              ], 8, _hoisted_79)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.deleteQuoteRecord(salesRec.SalesQuoteRecord))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                              ], 8, _hoisted_80)
                            ]),
                            (salesRec.SalesQuoteRecord.QuoteStatus < 3)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_81, _hoisted_83))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus == 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_84, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.confirmSalesQuote(salesRec.SalesQuoteRecord))
                                  }, [
                                    _hoisted_86,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.confirm), 1)
                                  ], 8, _hoisted_85)
                                ]))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus == 2)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_87, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.completeOrder(salesRec.SalesQuoteRecord))
                                  }, [
                                    _hoisted_89,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.lock), 1)
                                  ], 8, _hoisted_88)
                                ]))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus == 1)
                              ? (_openBlock(), _createElementBlock("li", {
                                  key: 3,
                                  title: _ctx.language.convert_to_order_title
                                }, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.convertQuoteToOrder(salesRec.SalesQuoteRecord))
                                  }, [
                                    _hoisted_92,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.convert), 1)
                                  ], 8, _hoisted_91)
                                ], 8, _hoisted_90))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus == 1)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_93, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.rejectSalesQuote(salesRec.SalesQuoteRecord))
                                  }, [
                                    _hoisted_95,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.reject), 1)
                                  ], 8, _hoisted_94)
                                ]))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus != 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_96, _hoisted_98))
                              : _createCommentVNode("", true),
                            (salesRec.SalesQuoteRecord.QuoteStatus != 0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_99, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item py-2",
                                    href: "javascript:;",
                                    onClick: ($event: any) => (_ctx.printSalesQuoteRecord(salesRec))
                                  }, [
                                    _hoisted_101,
                                    _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                                  ], 8, _hoisted_100)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.lstOfSalesQuotesInfo.length==0}])
            }, [
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("div", _hoisted_103, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.lstOfSalesQuotesInfo.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("nav", _hoisted_105, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredRecordItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_SalesQuoteModal, {
        visible: _ctx.isSalesQuoteVis,
        initialValues: _ctx.salesOrderData,
        recordStatus: _ctx.salesOrderStatus,
        listOfUsers: _ctx.listOfUsers,
        listOfCustomers: _ctx.listOfCustomers,
        selectedMonth: _ctx.selectedMonth,
        onCloseForm: _ctx.onDetailClose
      }, null, 8, ["visible", "initialValues", "recordStatus", "listOfUsers", "listOfCustomers", "selectedMonth", "onCloseForm"])
    ]))
  ], 64))
}